import * as Yup from 'yup'

export const getValidationSchema = () =>
  Yup.object().shape({
    shopId: Yup.number(),
    supportId: Yup.string().required('Tipul de suport este un câmp obligatoriu'),
    conform: Yup.number().min(0).required('Campul este obligatoriu.'),
    defect: Yup.number().min(0).required('Campul este obligatoriu.'),
    defectPictureId: Yup.number().nullable()
  })

export const initialValues = {
  shopId: null,
  supportId: null,
  conform: '',
  defect: '',
  defectPictureId: null
}
